<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
  <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="factureForm" @submit="editFacture" :validation-schema="factureSchema" :initial-values="factureForm">
          <div class="row">
           
            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Référence <span class="text-danger">*</span>
                  </label>
                  <Field name="reference" type="string" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la référence"/>
                  <ErrorMessage name="reference" class="text-danger"/>
                </div>
              </div>

            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date facture <span class="text-danger">*</span>
                  </label>
                  <Field name="date_facture" type="date" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la date de facture"/>
                  <ErrorMessage name="date_facture" class="text-danger"/>
                </div>
              </div>
  
            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                   Montant facture <span class="text-danger">*</span>
                  </label>
                  <Field name="montant_facture" type="number" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le montant"/>
                  <ErrorMessage name="montant_facture" class="text-danger"/>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                  Période facture <span class="text-danger">*</span>
                  </label>
                  <Field name="periode_facture" type="month" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la date de facture"/>
                  <ErrorMessage name="periode_facture" class="text-danger"/>
                </div>
              </div>


              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                Contrat<span class="text-danger">*</span>
                </label>
                <Field name="contrat" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="contratOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner le contrat"
                  label="label" track-by="label" />
                </Field>
                <ErrorMessage name="contrat" class="text-danger" />
              </div>
            </div>


        <div class="col-md-12 d-flex flex-column mt-3">
          <div class="d-flex align-items-center ">
            <button
              class="btn btn-success me-3"
              type="submit"
            >
                Modifier facture
            </button>
            <router-link to="/liste-factures" 
                class=" btn btn-danger"><i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
          </div>
        </div>
      </div>
    </Form>
  </div>
</div>
</template>

<script lang="ts">

import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRoute, useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import { Facture} from '@/models/Facture';
import * as Yup from 'yup';
import axios from 'axios';
import Multiselect from '@vueform/multiselect';
export default defineComponent({
    name: "EditFacture",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: () => {
    const factureSchema = Yup.object().shape({
      date_facture: Yup.string().required("Nom est obligatoire."),
        montant_facture: Yup.string().required("Prenom est obligatoire."),
        periode_facture: Yup.string().required("Période facture est obligatoire."),
        reference: Yup.string().required("Email est obligatoire."),
        contrat: Yup.string().required("Numero telephonique est obligatoire."),
    });
    const factureForm = ref<Facture>();
    const router = useRouter();
    const route = useRoute();
    const contrat = ref();
    const contratOptions = ref();
    function getFacture(id:number) {
      ApiService.get("/factures/"+id.toString())
        .then(({ data }) => {
          console.log("donné", data);
          for (const key in data.data) {
            factureForm.value?.setFieldValue(key, 
            (typeof data.data[key] === 'object' && data.data[key] !== null)? data.data[key].id :data.data[key]
          );
          }
      })
      .catch(({ response }) => {
        error(response.data.message);
      });
    }
const editFacture = async (values, { resetForm }) => {
  try {
    const response = await ApiService.put(`/factures/${values.id}`, values);
    if (response.status === 200) {
      success(response.data.message);
      resetForm();
      router.push({ name: "ListeFacturePage" });
    }
  } catch (error) {
 //   error(error.response?.data?.message || "Une erreur est survenue.");
  }
};
const getAllContrats = async () => {
          try{
          const response = await ApiService.get('/all/contrats');
          const contratsData = response.data.data.data;
          console.log('Data', contratsData)
          contratOptions.value = contratsData.map((contrat) => ({
            value: contrat.id,
            label: contrat.reference,
          }));
          }
          catch(error){
            //error(response.data.message)
          }
        }

onMounted(() => {
        getAllContrats();
            });

    onMounted(() => {
      if(route.params.id) {
        getFacture(parseInt(route.params.id as string));
      }
    });

    return { 
      editFacture,
          factureForm,
          contratOptions,
          contrat,
      factureSchema
    };
  },
});
</script>
